<template>
	<fade-transition :duration="200" origin="center top" mode="out-in">
		<div
			:class="contentClass"
			:style="[{ minHeight: contentHeight }, offsetStyle]"
			class="router-view nav-drawer-offset"
		>
			<router-view></router-view>
		</div>
	</fade-transition>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
	name: "app-content",
	props: {
		contentHeight: {
			type: String,
			default: `100vh`,
		},
		// Left offset while the navigation drawer is docked (LIQ-2643) - see App.vue.
		offsetStyle: {
			type: Object,
			default: () => ({}),
		},
	},
	components: {
		FadeTransition,
	},
	computed: {
		contentClass() {
			return this.$route.meta.flexContainer
				? "d-flex align-items-center justify-content-center"
				: "";
		},
	},
};
</script>
